import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isValidElement, useEffect, useRef, useState } from "react";
import { Contrast } from "../../../types/general.types";
import { LabelSizes, LabelVariants, LabelWeights, } from "../../../Atoms/Text/Label/constants";
import { Label } from "../../../Atoms";
import { UserAvatarSizes } from "../../../Molecules/Images/UserAvatar/constants";
import { Icon, UserAvatar } from "../..";
import { IconSizes, IconVariants, } from "../../Images/Icon/constants";
import StyledButton from "./Menu.style";
import { MenuButtonVariants, MenuButtonSizes, } from "./constants";
const Menu = ({ onClick = (e) => {
    e.preventDefault();
}, onMouseOver = () => { }, onMouseLeave = () => { }, isDisabled = false, variant = MenuButtonVariants.primary, contrast = Contrast.default, size = MenuButtonSizes.medium, textLabel = "", iconName = "", iconElement, imgUrl = "", }) => {
    const [onHover, setOnHover] = useState(false);
    const buttonRef = useRef(null);
    const [elementSize, setElementSize] = useState({ width: 0, height: 0 });
    const [useRatio, setUseRatio] = useState(false);
    useEffect(() => {
        const verifyElementSize = () => {
            if (buttonRef.current) {
                const width = buttonRef.current.offsetWidth || 0;
                const height = buttonRef.current.offsetHeight || 0;
                setElementSize({ width, height });
            }
        };
        window.addEventListener("resize", verifyElementSize);
        return () => {
            window.removeEventListener("resize", verifyElementSize);
        };
    }, []);
    useEffect(() => {
        size === MenuButtonSizes.full &&
            setUseRatio(elementSize.width <= elementSize.height);
    }, [elementSize]);
    const internalOnMouseLeave = () => {
        setOnHover(false);
        onMouseLeave;
    };
    const getLabelProps = (variant, isDisabled, contrast, size) => {
        const labelProps = {
            weight: LabelWeights.bold,
            size: size === MenuButtonSizes.medium ? LabelSizes.small : LabelSizes.medium,
        };
        if (isDisabled)
            return { labelProps, isDisabled: true, kind: LabelVariants.neutral };
        if (contrast === Contrast.dark)
            return {
                ...labelProps,
                variant: LabelVariants.neutral,
                contrast: Contrast.dark,
                isVariant: onHover,
            };
        if (contrast === Contrast.light)
            return {
                ...labelProps,
                variant: LabelVariants.neutral,
                contrast: Contrast.light,
                isVariant: onHover,
            };
        switch (variant) {
            case MenuButtonVariants.primary: {
                return {
                    ...labelProps,
                    variant: LabelVariants.neutral,
                    contrast: Contrast.dark,
                };
            }
            case MenuButtonVariants.secondary: {
                return {
                    ...labelProps,
                    variant: LabelVariants.neutral,
                    contrast: Contrast.dark,
                };
            }
            case MenuButtonVariants.neutral: {
                return {
                    ...labelProps,
                    variant: LabelVariants.neutral,
                    isVariant: onHover,
                };
            }
            case MenuButtonVariants.neutralOff: {
                return {
                    ...labelProps,
                    variant: LabelVariants.neutral,
                    isVariant: onHover,
                };
            }
        }
    };
    const getIconProps = (variant, isDisabled, contrast, size) => {
        const iconProps = {
            size: size === MenuButtonSizes.medium ? IconSizes.medium : IconSizes.large,
        };
        if (isDisabled)
            return { iconProps, isDisabled: true, kind: IconVariants.neutral };
        if (contrast === Contrast.dark)
            return {
                ...iconProps,
                variant: IconVariants.neutral,
                contrast: Contrast.dark,
                isColorVariant: onHover,
            };
        if (contrast === Contrast.light)
            return {
                ...iconProps,
                variant: IconVariants.neutral,
                contrast: Contrast.light,
                isColorVariant: onHover,
            };
        switch (variant) {
            case MenuButtonVariants.primary: {
                return {
                    ...iconProps,
                    variant: IconVariants.neutral,
                    contrast: Contrast.dark,
                };
            }
            case MenuButtonVariants.secondary: {
                return {
                    ...iconProps,
                    variant: IconVariants.neutral,
                    contrast: Contrast.dark,
                };
            }
            case MenuButtonVariants.neutral: {
                return {
                    ...iconProps,
                    variant: IconVariants.neutral,
                    isColorVariant: onHover,
                };
            }
            case MenuButtonVariants.neutralOff: {
                return {
                    ...iconProps,
                    variant: IconVariants.neutral,
                    isColorVariant: onHover,
                };
            }
        }
    };
    return (_jsxs(StyledButton, { ref: buttonRef, onClick: onClick, onMouseOver: onMouseOver, onMouseEnter: () => setOnHover(true), onMouseLeave: internalOnMouseLeave, isDisabled: isDisabled, variant: variant, contrast: contrast, useRatio: useRatio, ratioHeight: useRatio && elementSize.width, size: size, children: [imgUrl && (_jsx(UserAvatar, { imgUrl: imgUrl, avatarSize: size === MenuButtonSizes.medium
                    ? UserAvatarSizes.small
                    : UserAvatarSizes.medium, contrast: contrast })), iconName && !imgUrl && (_jsx(Icon, { name: iconName, ...getIconProps(variant, isDisabled, contrast, size) })), !iconName && !imgUrl && isValidElement(iconElement) && iconElement, textLabel && (_jsx(Label, { ...getLabelProps(variant, isDisabled, contrast, size), children: textLabel }))] }));
};
export default Menu;
//# sourceMappingURL=Menu.js.map